import { instance } from './ApiRequest';
import {
    ANSWER_KEY_GET_FOR_CANDIDATE, ANSWER_KEY_GET_ALL, ANSWER_KEY_GET_BY_ID, ANSWER_KEY_CREATE,
    ANSWER_KEY_PUBLISH, ANSWER_KEY_UNPUBLISH, ANSWER_KEY_ARCHIVE, ANSWER_KEY_SUPERSEDE,
    ANSWER_KEY_OBJECTION_SUBMIT, ANSWER_KEY_OBJECTION_GET_MINE, ANSWER_KEY_OBJECTION_GET_MY_PROOF_URL,
    ANSWER_KEY_OBJECTION_SEARCH, ANSWER_KEY_OBJECTION_GET_BY_ID, ANSWER_KEY_OBJECTION_GET_PROOF_URL,
    ANSWER_KEY_OBJECTION_UPDATE_STATUS
} from 'constants/constants';

// Phase C.9 (Answer Key & Lightweight Online Objection Workflow) — a dedicated module for the new
// backend surface, following the same "one small module per related API surface" convention
// PublicationService.js/EnterpriseOpsService.js already established.
let _AnswerKeyService = {
    // Candidate-facing, authenticated (student auth-token) — NEVER anonymous, unlike Publication.
    async getForCandidate() {
        return await instance.get(ANSWER_KEY_GET_FOR_CANDIDATE);
    },
    async submitObjection(model, proofFile) {
        const body = new FormData();
        body.append('AnswerKeyId', model.AnswerKeyId);
        body.append('QuestionReference', model.QuestionReference || '');
        body.append('ObjectionText', model.ObjectionText || '');
        if (proofFile) {
            body.append('files[]', proofFile);
        }
        return await instance.post(ANSWER_KEY_OBJECTION_SUBMIT, body);
    },
    async getMyObjections() {
        return await instance.get(ANSWER_KEY_OBJECTION_GET_MINE);
    },
    async getMyProofAccessUrl(objectionId) {
        return await instance.get(ANSWER_KEY_OBJECTION_GET_MY_PROOF_URL + "?objectionId=" + objectionId);
    },

    // Admin-facing, Global-Admin-gated on the backend.
    async getAll() {
        return await instance.get(ANSWER_KEY_GET_ALL);
    },
    async getById(id) {
        return await instance.get(ANSWER_KEY_GET_BY_ID + "?id=" + id);
    },
    async create(model, file) {
        const body = new FormData();
        appendAnswerKeyFields(body, model);
        body.append('files[]', file);
        return await instance.post(ANSWER_KEY_CREATE, body);
    },
    async publish(id) {
        return await instance.post(ANSWER_KEY_PUBLISH + "?id=" + id);
    },
    async unpublish(id) {
        return await instance.post(ANSWER_KEY_UNPUBLISH + "?id=" + id);
    },
    async archive(id) {
        return await instance.post(ANSWER_KEY_ARCHIVE + "?id=" + id);
    },
    async supersede(existingAnswerKeyId, model, file) {
        const body = new FormData();
        appendAnswerKeyFields(body, model);
        body.append('files[]', file);
        return await instance.post(ANSWER_KEY_SUPERSEDE + "?existingAnswerKeyId=" + existingAnswerKeyId, body);
    },

    async searchObjections(postId, classRoomId, status) {
        const params = [];
        if (postId) params.push('postId=' + postId);
        if (classRoomId) params.push('classRoomId=' + classRoomId);
        if (status) params.push('status=' + encodeURIComponent(status));
        return await instance.get(ANSWER_KEY_OBJECTION_SEARCH + (params.length ? '?' + params.join('&') : ''));
    },
    async getObjectionById(id) {
        return await instance.get(ANSWER_KEY_OBJECTION_GET_BY_ID + "?id=" + id);
    },
    async getObjectionProofAccessUrl(objectionId) {
        return await instance.get(ANSWER_KEY_OBJECTION_GET_PROOF_URL + "?objectionId=" + objectionId);
    },
    async updateObjectionStatus(model) {
        return await instance.post(ANSWER_KEY_OBJECTION_UPDATE_STATUS, model);
    }
};

function appendAnswerKeyFields(body, model) {
    body.append('PostId', model.PostId || 0);
    body.append('ClassRoomId', model.ClassRoomId || 0);
    body.append('AnswerKeyType', model.AnswerKeyType || '');
    body.append('ObjectionWindowStart', model.ObjectionWindowStart || '');
    body.append('ObjectionWindowEnd', model.ObjectionWindowEnd || '');
}

export default _AnswerKeyService;
